export default {
  title: 'بوابات الدفع',
  subtitle: 'إدارة خيارات بوابات الدفع',
  createPaymentGateway: 'إنشاء بوابة دفع',
  editPaymentGateway: 'تعديل بوابة دفع',
  deletePaymentGateway: 'حذف بوابة دفع',
  addNew: 'إضافة بوابة دفع',
  breadcrumbs: {
    paymentGateways: 'بوابات الدفع',
    create: 'إنشاء',
    edit: 'تعديل',
  },
  table: {
    displayOrder: 'ترتيب العرض',
    reorder: 'إعادة ترتيب بوابات الدفع',
    name: 'الاسم',
    isActive: 'الحالة',
    currencyCode: 'العملة',
    type: 'النوع',
    commissionType: 'نوع العمولة',
    createdAt: 'تاريخ الإنشاء',
    actions: 'الإجراءات',
  },
  fields: {
    name: 'الاسم',
    currencyCode: 'العملة',
    displayOrder: 'ترتيب العرض',
    isActive: 'نشط',
    type: 'النوع',
    commissionType: 'نوع العمولة',
    commissionPercent: 'نسبة العمولة (%)',
    commissionValue: 'قيمة العمولة',
    logo: 'الشعار',
    additionalProperties: 'خصائص إضافية',
  },
  typeOptions: {
    disabled: 'معطل',
    enabledWhatsapp: 'مفعل (واتساب)',
    enabledOnlinePayment: 'مفعل (دفع إلكتروني)',
  },
  commissionTypeOptions: {
    percent: 'نسبة مئوية',
    value: 'قيمة',
    percentAndValue: 'نسبة مئوية وقيمة',
  },
  placeholders: {
    name: 'أدخل اسم بوابة الدفع',
    currencyCode: 'اختر العملة',
    displayOrder: 'اتركه فارغاً لوضعه في النهاية',
    commissionPercent: 'أدخل نسبة العمولة',
    commissionValue: 'أدخل قيمة العمولة',
    logo: 'JPG أو PNG أو GIF أو WebP. الحد الأقصى 5 ميغابايت.',
    additionalPropertyKey: 'مفتاح الخاصية',
    additionalPropertyValue: 'قيمة الخاصية',
  },
  buttons: {
    addProperty: 'إضافة خاصية',
  },
  validation: {
    nameRequired: 'الاسم مطلوب',
    nameMinLength: 'يجب أن يكون الاسم أكثر من حرفين',
    nameMaxLength: 'يجب ألا يتجاوز الاسم 100 حرف',
    currencyCodeRequired: 'العملة مطلوبة',
    displayOrderRange: 'يجب أن يكون ترتيب العرض رقماً صحيحاً أكبر من أو يساوي 0',
    commissionPercentRequired: 'نسبة العمولة مطلوبة',
    commissionPercentRange: 'يجب أن تكون نسبة العمولة بين 0 و 100',
    commissionValueRequired: 'قيمة العمولة مطلوبة',
    commissionValueMin: 'يجب أن تكون قيمة العمولة أكبر من أو تساوي 0',
  },
  messages: {
    fetchError: 'فشل في جلب بوابات الدفع',
    createError: 'فشل في إنشاء بوابة الدفع',
    createSuccess: 'تم إنشاء بوابة الدفع بنجاح',
    updateError: 'فشل في تحديث بوابة الدفع',
    updateSuccess: 'تم تحديث بوابة الدفع بنجاح',
    logoUploadError: 'تم حفظ بوابة الدفع ولكن فشل رفع الشعار',
    deleteError: 'فشل في حذف بوابة الدفع',
    deleteSuccess: 'تم حذف بوابة الدفع بنجاح',
    deleteConfirm: 'هل أنت متأكد من حذف بوابة الدفع هذه؟',
    reorderSuccess: 'تم تحديث ترتيب بوابات الدفع بنجاح',
    reorderError: 'فشل تحديث ترتيب بوابات الدفع',
    dragToReorder: 'اسحب وأفلت الصفوف للتحكم في ترتيب الدفع في الموقع.',
    reorderSearchDisabled: 'امسح حقل البحث لتتمكن من إعادة ترتيب القائمة كاملة.',
    reordering: 'جارٍ حفظ ترتيب بوابات الدفع...',
    noPaymentGateways: 'لم يتم العثور على بوابات دفع',
  },
};
